import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

export const CustomSwitch = styled(Switch)(({ theme }) => ({
    width: 48,
    height: 32,
    padding: 0,
    margin: theme.spacing(1),
    '& .MuiSwitch-switchBase': {
        paddingTop: 3.5,
        paddingLeft: 3.5,
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: theme.palette.common.white,
            '& + .MuiSwitch-track': {
                backgroundColor: '#182E45',
                opacity: 1,
                border: 'none',
            },
            '& .MuiSwitch-thumb': {
                backgroundColor: '#fff',
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#52d869',
            border: '6px solid #fff',
        },
    },
    '& .MuiSwitch-thumb': {
        width: 24,
        height: 24,
        padding: 0,
        backgroundColor: '#9B9A9A',
    },
    '& .MuiSwitch-track': {
        borderRadius: '100px',
        border: '1px solid var(--Neutral-Neutral-6, #C7C7C7)',
        backgroundColor: '#C7C7C7',
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
    },
}));